import React from 'react';
import clock from '../../../assets/icons/clock.svg'
import location from '../../../assets/icons/marker.svg'
import phone from '../../../assets/icons/phone.svg'


const Infocards = () => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12'>
            <div className="card md:card-side bg-primary bg-gradient-to-r from-primary to-secondary shadow-xl p-6 text-white">
                <figure><img className='' src={clock} alt="Movie" /></figure>
                <div className="card-body">
                    <h2 className="card-title">Opening Hours!</h2>
                    <p>Mon-fri :   9am -10pm <br />sat-sun : 9am-6pm</p>

                </div>
            </div>
            <div className="card md:card-side  bg-gradient-to-r from-pink-500 to-orange-200 p-6 shadow-xl text-white">
                <figure><img src={location} alt="Movie" /></figure>
                <div className="card-body">
                    <h2 className="card-title">Visit our Location !</h2>
                    <p> IIUM, Gombak ,selangor </p>

                </div>
            </div>
            <div className="card md:card-side  shadow-xl bg-primary p-6 bg-gradient-to-r from-primary to-secondary text-white">
                <figure><img src={phone} alt="Movie" /></figure>
                <div className="card-body">
                    <h2 className="card-title">Contact us Now !</h2>
                    <p>+08667667</p>

                </div>
            </div>
        </div>
    );
};

export default Infocards;